import React, { useEffect } from 'react';
import { Result, Button } from 'antd';
import { useLocation } from 'react-router-dom';

const ErrorPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const error = params.get('error');

  useEffect(() => {
    const newUrl = window.location.pathname;
    window.history.replaceState({}, '', newUrl);
  }, []);

  const getErrorConfig = () => {
    if (error === 'logout') {
      return {
        status: 'info',
        title: 'Signed Out',
        subTitle: 'You have successfully signed out',
      };
    }else if (error === 'disable') {
      return {
        status: 'error',
        title: 'User Disabled',
        subTitle: 'Your account has been disabled, please contact the administrator',
      };
    }

    return {
      status: 'error',
      title: 'SSO Authentication Failed',
      subTitle: decodeURIComponent(error) || 'The authentication process encountered an error',
    };
  };

  const errorConfig = getErrorConfig();
  
  return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Result
        status={errorConfig.status}
        title={errorConfig.title}
        subTitle={errorConfig.subTitle}
        extra={[
          <Button 
            type="primary" 
            key="retry"
            onClick={() => window.location.href = '/'}
          >
            {error === 'logout' ? 'Sign In Again' : 'Retry'}
          </Button>
        ]}
      />
    </div>
  );
};

export default ErrorPage;